import React from 'react';
import { cloneDeep } from '../../utils/lodash';

export const viewDeepCopy = (initialViewId, data, saveNewView) => {
  return new Promise((resolve, reject) => {
    const viewsChangedTo = {};
    const newViews = {};

    const copyDataViews = (views) => {
      Object.values(views).forEach(view => saveNewView(cloneDeep(view), (newView) => {
        newViews[newView.id] = newView;
        viewsChangedTo[view.id] = newView.id;

        if ((Object.keys(newViews).length) === Object.keys(data).length) {
          let processed = 0;
          Object.values(newViews).forEach((view) => {
            updateProperties(view);
            processed = processed + 1;
          });

          if (viewsChangedTo[initialViewId]) {
            const newInitialView = newViews[viewsChangedTo[initialViewId]];
            console.log('new initial view: ', newInitialView);
            
            if (processed === Object.keys(data).length) resolve({ newViews, viewsChangedTo, newInitialView });
          }
        }
      }));
    };

    const updateProperties = (view) => {
      if (view.show_pids) {
        view.show_pids.forEach((column) => {
          if (column && column.obj_editable_frm) {
            updateProperty(column, 'obj_editable_frm');
          }
        });
      }

      if (view.buttons && view.buttons.editNode) {
        updateProperty(view.buttons, 'editNode');
      }

      if (view.groups && view.groups.length) {
        view.groups.forEach((row) => {
          row.forEach((group) => {
            if (group.items) group.items.forEach(item => updateProperty(item, 'obj_editable_frm'));
            if (group.links) group.links.forEach(link => updateProperty(link, 'jel'));
            ['tableId', 'frmId', 'frmEditId'].forEach((prop) => updateProperty(group, prop));
          });
        });
      }
    };

    const updateProperty = (obj, prop) => {
      const oldViewId = obj[prop];
      const newViewId = viewsChangedTo[oldViewId];
      if (newViewId) {
        obj[prop] = newViewId;
      }
      else console.log('view not found:', obj, prop, newViewId);
    };

    copyDataViews(data);
  });
};
